module.exports = __webpack_public_path__ + "static/media/Chat.10457586.svg";